import type PptxGenJS from '@meitu/js-to-pptx';
import { pxToInch } from '@/utils/unit-kit';
import type { ILayerProps, ISlide } from '@/version-types';
import { renderLayerContentToCanvas } from './render-to-canvas';

/**
 * 将标注图层导出为 PPT 图片
 *
 * @param slide - PPT 幻灯片对象
 * @param layer - 图层属性
 * @param identity - 框架实例标识
 */
export const renderLayerToPPT = async (slide: ISlide, layer: ILayerProps, identity: string) => {
    const canvas = await renderLayerContentToCanvas(layer, identity, true);
    const { left, top, width, height, rotate } = layer;
    const options: PptxGenJS.ImageProps = {
        x: pxToInch(left),
        y: pxToInch(top),
        w: pxToInch(width),
        h: pxToInch(height),
        rotate: rotate > 0 ? rotate : 360 + rotate, // 0 - 360
    };

    options.data = canvas?.toDataURL() || '';

    slide.addImage(options);
};
